module.exports = __webpack_public_path__ + "static/blog42-776e1ee268a5b5369e608578d8c377b0.png";